module.exports = __webpack_public_path__ + "static/goodfirms-a70eab29fb34dd50b7bb286f855aa104.svg";